import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import Season from './season-model'
import {
  CreateSeasonAsync,
  DeleteSeasonAsync,
  LoadSeasonsAsync,
} from './season-thunk'
const initialState: seasonSliceState = {
  season: [],
  selected_season: '',
  is_loading_season: false,
  is_creating_season: false,
  is_deleting_season: false,
}
export interface seasonSliceState {
  season: Season[]
  selected_season?: string
  is_loading_season: boolean
  is_creating_season: boolean
  is_deleting_season: boolean
}
export const seasonSlice = createSlice({
  name: 'season',
  initialState,
  reducers: {
    setSelectedseason: (state, action) => {
      state.selected_season = action.payload
    },
    clearStateseason: (state) => {
      state.season = []
      state.is_loading_season = false
      state.is_creating_season = false
      state.is_deleting_season = false
    },
    mergeseason: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_season = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.season = merge(state.season, payload) as any
        }
      }
    },

    add_season: (state, action) => {
      if (action.payload) {
        state.season = [...state.season, action.payload]
      }
    },
    set_season: (state, action) => {
      let { key, value, id } = action.payload
      state.season = state.season.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadSeasonsAsync.pending, (state) => {
      state.is_loading_season = true
    })
    builder.addCase(LoadSeasonsAsync.fulfilled, (state, action) => {
      state.is_loading_season = false
      if (action.payload) {
        state.season = action.payload
      }
    })
    builder.addCase(LoadSeasonsAsync.rejected, (state) => {
      state.is_loading_season = false
    })
    builder.addCase(CreateSeasonAsync.pending, (state) => {
      state.is_creating_season = true
    })
    builder.addCase(CreateSeasonAsync.fulfilled, (state) => {
      state.is_creating_season = false
    })
    builder.addCase(CreateSeasonAsync.rejected, (state) => {
      state.is_creating_season = false
    })
    builder.addCase(DeleteSeasonAsync.pending, (state) => {
      state.is_deleting_season = true
    })
    builder.addCase(DeleteSeasonAsync.fulfilled, (state, action) => {
      state.is_deleting_season = false
      if (state.season) {
        state.season = state.season.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeleteSeasonAsync.rejected, (state) => {
      state.is_deleting_season = false
    })

    builder.addCase(
      autoThunks.fetch_season_for_series_approval_evaluation.pending,
      (state) => {
        state.is_loading_season = true
      },
    )
    builder.addCase(
      autoThunks.fetch_season_for_series_approval_evaluation.fulfilled,
      (state, action) => {
        state.is_loading_season = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.fetch_season_for_series_approval_evaluation.rejected,
      (state) => {
        state.is_loading_season = false
      },
    )

    builder.addCase(autoThunks.get_content_house_seasons.pending, (state) => {
      state.is_loading_season = true
    })
    builder.addCase(
      autoThunks.get_content_house_seasons.fulfilled,
      (state, action) => {
        state.is_loading_season = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_content_house_seasons.rejected, (state) => {
      state.is_loading_season = false
    })

    builder.addCase(autoThunks.storeSeasonForContentHouse.pending, (state) => {
      state.is_loading_season = true
    })
    builder.addCase(
      autoThunks.storeSeasonForContentHouse.fulfilled,
      (state, action) => {
        state.is_loading_season = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.storeSeasonForContentHouse.rejected, (state) => {
      state.is_loading_season = false
    })

    builder.addCase(
      autoThunks.get_seasons_for_system_schedules.pending,
      (state) => {
        state.is_loading_season = true
      },
    )
    builder.addCase(
      autoThunks.get_seasons_for_system_schedules.fulfilled,
      (state, action) => {
        state.is_loading_season = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_seasons_for_system_schedules.rejected,
      (state) => {
        state.is_loading_season = false
      },
    )
  },
})

function handleResult(action: any, state: seasonSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_season = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.season = merge(state.season, payload) as any
    }
  }
}

export const {
  clearStateseason,
  setSelectedseason,
  set_season,
  mergeseason,
  add_season,
} = seasonSlice.actions

export const get_season =
  (id?: string) =>
  (state: {
    season: {
      season: Season[]
    }
  }): Season | null => {
    let temp = state?.season?.season?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.season?.season[0] || null
  }
export const get_selected_season = (state: {
  season: seasonSliceState
}): Season | null => {
  let id = state?.season?.selected_season
  let temp = state?.season?.season?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_season = (state: {
  season: {
    season: Season[]
  }
}): Season[] => {
  let temp = state?.season?.season
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_season_busy = (state: { season: seasonSliceState }) => {
  return (
    state?.season.is_deleting_season ||
    state?.season.is_loading_season ||
    state?.season.is_creating_season
  )
}
export const is_deleting_season_busy = (state: {
  season: seasonSliceState
}) => {
  return state?.season.is_deleting_season
}
export const is_loading_season_busy = (state: { season: seasonSliceState }) => {
  return state?.season.is_loading_season
}
export const is_creating_season_busy = (state: {
  season: seasonSliceState
}) => {
  return state?.season.is_creating_season
}

export default seasonSlice.reducer
